import { Share2, Copy, Mail } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";

export default function ShareMenu({ url, text, label = "Condividi", variant = "outline", size = "sm", align = "start", testid = "share", icon = true, className, emailSubject }) {
  const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");
  const shareText = text || shareUrl;

  const whatsapp = () => window.open(`https://wa.me/?text=${encodeURIComponent(shareText)}`, "_blank");
  const email = () => {
    window.location.href = `mailto:?subject=${encodeURIComponent(emailSubject || "Libri in Circolo")}&body=${encodeURIComponent(shareText)}`;
  };
  const copy = async () => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(shareUrl);
      } else {
        const ta = document.createElement("textarea");
        ta.value = shareUrl; ta.style.position = "fixed"; ta.style.opacity = "0";
        document.body.appendChild(ta); ta.select();
        document.execCommand("copy"); document.body.removeChild(ta);
      }
      toast.success("Link copiato negli appunti");
    } catch { toast.error("Impossibile copiare il link"); }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={variant} size={size} data-testid={`${testid}-button`} className={className}>
          {icon && <Share2 className="w-4 h-4 mr-2" />}{label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align} className="z-[1200]">
        <DropdownMenuItem data-testid={`${testid}-whatsapp`} onClick={whatsapp} className="cursor-pointer">
          <svg viewBox="0 0 24 24" className="w-4 h-4 mr-2 fill-[#25D366]"><path d="M17.5 14.4c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.6.1-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-1.7-.8-2.8-1.5-3.9-3.4-.3-.5.3-.5.8-1.5.1-.2 0-.4 0-.5s-.6-1.5-.9-2c-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.5.1-.7.3-.2.2-.9.9-.9 2.2s.9 2.5 1 2.7c.1.2 1.8 2.8 4.4 3.9 1.6.7 2.2.8 3 .6.5-.1 1.7-.7 1.9-1.3.2-.6.2-1.2.2-1.3-.1-.1-.3-.2-.6-.3zM12 2a10 10 0 00-8.7 15l-1.3 4.7 4.8-1.3A10 10 0 1012 2z"/></svg>
          Invia su WhatsApp
        </DropdownMenuItem>
        <DropdownMenuItem data-testid={`${testid}-email`} onClick={email} className="cursor-pointer">
          <Mail className="w-4 h-4 mr-2" />Invia via email
        </DropdownMenuItem>
        <DropdownMenuItem data-testid={`${testid}-copy`} onClick={copy} className="cursor-pointer">
          <Copy className="w-4 h-4 mr-2" />Copia link
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
